var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Lynx-Label',{attrs:{"label":"Status"}}),_c('Treeselect',{attrs:{"multiple":false,"options":_vm.listaStatus,"placeholder":"Selecione o status"},model:{value:(_vm.internalStatus),callback:function ($$v) {_vm.internalStatus=$$v},expression:"internalStatus"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }